import { render, staticRenderFns } from "./CoozzyInstagramIcon.vue?vue&type=template&id=2b88d266&scoped=true"
import script from "./CoozzyInstagramIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyInstagramIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyInstagramIcon.vue?vue&type=style&index=0&id=2b88d266&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b88d266",
  null
  
)

export default component.exports